import React from "react";

interface ProductOrdered {
  name: string;
  price: number;
  quantity: number;
  product_id: number;
  order_type: string;
  product_image?: string;
  height?: number;
  width?: number;
  length?: number;
  weight?: number;
}

interface Order {
  id: number;
  status: string;
  address_id: string;
  vat: number;
  grand_total: number;
  total_price: number;
  date_ordered: string | null;
  requested_ship_date: string | null;
  reference_number: string;
  user_id: number;
  products: ProductOrdered[];
  receipt_url: string | null;
}

interface ProductDetailsProps {
  editingOrder: Order;
}

const OrderDetails: React.FC<ProductDetailsProps> = ({ editingOrder }) => {
  return (
    <div>
      <div>
        {editingOrder && (
          <div>
            <div>
              <div className=" mb-[15px]">
                
                <h3 className="box-border text-[#002238] cursor-pointer text-[18px] font-normal 
                h-[21px] leading-normal m-0 p-0 text-left">
                  Order Reference : {editingOrder.reference_number}
                </h3>
              </div>

              <div>
                {editingOrder.products.map((product) => (
                  <div>
                    <div className=" bg-white  mb-4 ">
                      <div className="flex items-center space-x-4 mb-4">
                        <div className="flex-1">
                          <div className="flex items-center justify-between"></div>
                          <div className="flex items-center justify-between ]">
                            <div className="flex mt-[3%]">
                              <div>
                                <div className="border-b p-2 bg-white text-left font-bold">
                                  <img
                                    className="w-10 h-30 object-cover"
                                    src={product.product_image}
                                    alt="product"
                                  />
                                </div>
                              </div>

                              <div className="p-4">
                                <p
                                  className="  box-border
                                     text-[#002238] cursor-pointer text-[16px] font-normal h-[21px] 
                                     leading-normal m-0 p-0 text-left ">
                                  {product.name}
                                </p>
                              </div>
                            </div>
                            <div className="mt-[-5%]">
                              <p className="text-sm text-gray-600 box-border  cursor-pointer
                               font-normal h-[21px] leading-normal m-0 text-left p-4 ">
                                Quantity: {product.quantity}{" "}
                              </p>
                              <p className="text-sm  box-border text-[#002238] cursor-pointer
                               font-normal h-[21px] leading-normal m-0 text-left  p-4">
                                Price: {product.price}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <ul></ul>
          </div>
        )}
      </div>

      <h4 className="text-lg font-semibold">
        Grand Total: {editingOrder.grand_total}
      </h4>
    </div>
  );
};

export default OrderDetails;
